import { LOCAL_STORAGE__LOCALE } from '../utils/constants.js';

export const getNavigatorLanguage = () => {
  return localStorage.getItem(LOCAL_STORAGE__LOCALE) || navigator.language.split(/[-_]/)[0];
};
